module.exports = __webpack_public_path__ + "static/media/cal-2.1a7c5007.jpeg";